import {
  CDateRangePicker,
  CMultiSelect,
  CFormSelect
} from "@coreui/react-pro";
import { removeDuplicates } from "src/helpers/remove-duplicates";
import {
  priceOptions,
  statusOptions
} from "src/helpers/data";


export const columnServiceList = (
  filterServiceName,
  filterServiceCategory,
  filterServicePrice,
  setFilterServiceName,
  setFilterServiceCategory,
  setFilterServicePrice
) => {
  return [
    {
      key: "service_uuid",
      label: "Code",
      _style: { width: '10%' },
      filter: false,
      sorter: false
    },
    {
      key: "title",
      label: "Service Name",
      _style: { width: '20%' },
      sorter: false,
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort()
        const options = unique.map((element) => {
          return {
            value: element.toLowerCase(),
            text: element,
          }
        })
        return (
          <CMultiSelect
            size="sm"
            options={
              filterServiceName && filterServiceName.length > 0 ?
                removeDuplicates(filterServiceName.concat(options)) : options
            }
            onChange={(selected) => {
              setFilterServiceName(selected)
              const _selected = selected.map((element) => {
                return element.value
              })
              onChange((item) => {
                return Array.isArray(_selected) && _selected.length
                  ? _selected.includes(item.toLowerCase())
                  : true
              })
            }}
          />
        )
      },
    },
    {
      key: "category_name",
      label: "Category",
      _style: { width: '20%' },
      sorter: false,
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort()
        const options = unique.map((element) => {
          return {
            value: element.toLowerCase(),
            text: element,
          }
        })
        return (
          <CMultiSelect
            size="sm"
            options={
              filterServiceCategory && filterServiceCategory.length > 0 ?
                removeDuplicates(filterServiceCategory.concat(options)) : options
            }
            onChange={(selected) => {
              setFilterServiceCategory(selected)
              const _selected = selected.map((element) => {
                return element.value
              })
              onChange((item) => {
                return Array.isArray(_selected) && _selected.length
                  ? _selected.includes(item.toLowerCase())
                  : true
              })
            }}
          />
        )
      },
    },
    {
      key: "price",
      label: "Price",
      _style: { width: '20%' },
      sorter: false,
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort()
        const options = unique.map((element) => {
          return {
            value: element,
            text: element,
          }
        })
        return (
          // <CMultiSelect
          //   size="sm"
          //   options={
          //     filterServicePrice && filterServicePrice.length > 0 ?
          //       removeDuplicates(filterServicePrice.concat(options)) : options
          //   }
          //   onChange={(selected) => {
          //     setFilterServicePrice(selected)
          //     const _selected = selected.map((element) => {
          //       return element.value
          //     })
          //     onChange((item) => {
          //       return Array.isArray(_selected) && _selected.length
          //         ? _selected.includes(item.toLowerCase())
          //         : true
          //     })
          //   }}
          // />
          <CFormSelect
            size="sm"
            options={priceOptions}
            value={filterServicePrice}
            onChange={({ target: { value } }) => {
              setFilterServicePrice(value)
              onChange((item) => {
                if (value !== 'Select...') {
                  const itemPrice = parseInt(item)
                  const itemValue = value.split(" - ")
                  if (itemValue[1]) {
                    return itemPrice >= parseInt(itemValue[0]) && itemPrice <= parseInt(itemValue[1])
                  } else {
                    return itemPrice > parseInt(itemValue[0])
                  }
                } else {
                  return true
                }
              })
            }}
          />
        )
      },
    },
    {
      key: "createdAt",
      label: "Created On",
      _style: { width: '10%' },
      filter: false,
      sorter: true
    },
    {
      key: "action",
      label: "",
      _style: { width: '15%' },
      filter: false,
      sorter: false
    },
  ];
}

export const columnCategoryList = (
  startDate,
  endDate,
  setStartDate,
  setEndDate
) => {
  return [
    {
      key: "name",
      label: "Category",
      _style: { width: '15%' },
      filter: false,
      sorter: false
    },
    {
      key: "description",
      label: "Description",
      _style: { width: '30%' },
      filter: false,
      sorter: false
    },
    {
      key: "services_count",
      label: "Under This Category",
      _style: { width: '15%' },
      filter: false,
      sorter: false,
    },
    {
      key: "createdAt",
      label: "Created On",
      _style: { width: '20%' },
      sorter: true,
      filter: (values, onChange) => {
        return (
          <CDateRangePicker
            size="sm"
            startDate={startDate}
            endDate={endDate}
            // maxDate={new Date()}
            onStartDateChange={(date) => {
              setStartDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return endDate ? itemDate >= date && itemDate <= endDate : itemDate >= date
                }
                return true
              })
            }}
            onEndDateChange={(date) => {
              setEndDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return startDate ? itemDate <= date && itemDate >= startDate : itemDate <= date
                }
                return true
              })
            }}
          />
        )
      },
    },
    {
      key: "action",
      label: "",
      _style: { width: '13%' },
      filter: false,
      sorter: false,
    },
  ];
}

export const columnBookingList = (
  startCreatedDate,
  endCreatedDate,
  startBookingDate,
  endBookingDate,
  filterBookingStatus,
  filterBookingAmount,
  filterPaymentMethod,
  filterServicePackage,
  setStartDate,
  setEndDate,
  setStartBookingDate,
  setEndBookingDate,
  setFilterBookingStatus,
  setFilterBookingAmount,
  setFilterPaymentMethod,
  setFilterServicePackage,
  setActiveBookingListPage,
  servicePackageList,
  paymentMethodList
) => {
  return [
    {
      key: "booking_uuid",
      label: "Booking No.",
      _style: { width: '7%' },
      filter: false,
      sorter: false,
    },
    {
      key: "customer_name",
      label: "Customer Name",
      _style: { width: '10%' },
      filter: false,
      sorter: false
    },
    {
      key: "service_variant",
      label: "Service Package",
      _style: { width: '13%' },
      sorter: false,
      filter: (values, onChange) => {
        const servicePackageOptions = servicePackageList.map((element) => {
          return {
            value: element.id,
            label: element.title && element.service && element.service.title ? `${element.service.title} (${element.title})` : '-',
          }
        })
        return (
          <CFormSelect
            size="sm"
            options={[
              {
                value: '',
                label: 'Select...',
              },
              ...servicePackageOptions
            ]}
            value={filterServicePackage}
            onChange={({ target: { value } }) => {
              setFilterServicePackage(value)
              setActiveBookingListPage(1)
            }}
          />
        )
      },
    },
    {
      key: "payment_method",
      label: "Payment Method",
      _style: { width: '13%' },
      sorter: false,
      filter: (values, onChange) => {
        const paymentMethodOptions = paymentMethodList.map((element) => {
          return {
            value: element.id,
            label: element.name
          }
        })
        return (
          <CFormSelect
            size="sm"
            options={[
              {
                value: '',
                label: 'Select...',
              },
              ...paymentMethodOptions
            ]}
            value={filterPaymentMethod}
            onChange={({ target: { value } }) => {
              setFilterPaymentMethod(value)
              setActiveBookingListPage(1)
            }}
          />
        )
      },
    },
    {
      key: "booking_amount",
      label: "Total Amount",
      _style: { width: '13%' },
      sorter: false,
      filter: (values, onChange) => {
        return (
          <CFormSelect
            size="sm"
            options={priceOptions}
            value={filterBookingAmount}
            onChange={({ target: { value } }) => {
              setFilterBookingAmount(value)
              setActiveBookingListPage(1)
            }}
          />
        )
      },
    },
    {
      key: "booking_date",
      label: "Booking Date",
      _style: { width: '13%' },
      sorter: true,
      filter: (values, onChange) => {
        return (
          <CDateRangePicker
            size="sm"
            startDate={startBookingDate}
            endDate={endBookingDate}
            // maxDate={new Date()}
            onStartDateChange={(date) => {
              setStartBookingDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return endBookingDate ? itemDate >= date && itemDate <= endBookingDate : itemDate >= date
                }
                return true
              })
            }}
            onEndDateChange={(date) => {
              setEndBookingDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return startBookingDate ? itemDate <= date && itemDate >= startBookingDate : itemDate <= date
                }
                return true
              })
            }}
          />
        )
      },
    },
    {
      key: "createdAt",
      label: "Purchase On",
      _style: { width: '13%' },
      sorter: true,
      filter: (values, onChange) => {
        return (
          <CDateRangePicker
            size="sm"
            startDate={startCreatedDate}
            endDate={endCreatedDate}
            onStartDateChange={(date) => {
              setStartDate(date)
              setActiveBookingListPage(1)
            }}
            onEndDateChange={(date) => {
              setEndDate(date)
              setActiveBookingListPage(1)
            }}
          />
        )
      },
    },
    {
      key: "status",
      label: "Status",
      _style: { width: '10%' },
      sorter: false,
      filter: (values, onChange) => {
        return (
          <CFormSelect
            size="sm"
            options={statusOptions}
            value={filterBookingStatus}
            onChange={({ target: { value } }) => {
              setFilterBookingStatus(value)
              setActiveBookingListPage(1)
            }}
          />
        )
      },
    },
    {
      key: "action",
      label: "",
      _style: { width: '12%' },
      filter: false,
      sorter: false
    },
  ]
};

export const columnCustomerList = () => {
  return [
    {
      key: "user_uuid",
      label: "Customer ID",
      filter: false,
      sorter: false,
    },
    {
      key: "first_name",
      label: "First Name",
      filter: false,
      sorter: true
    },
    {
      key: "last_name",
      label: "Last Name",
      filter: false,
      sorter: true
    },
    {
      key: "email",
      label: "Email Address",
      filter: false,
      sorter: false
    },
    {
      key: "first_booking_on",
      label: "First Booking On",
      filter: false,
      sorter: true
    },
    {
      key: "action",
      label: "",
      filter: false,
      sorter: false
    },
  ]
};

export const columnNewsletterSubscription = () => {
  return [
    {
      key: "email",
      label: "Email",
      filter: false,
      sorter: false
    },
    {
      key: "createdAt",
      label: "Created On",
      sorter: false,
      filter: false
      // filter: (values, onChange) => {
      //   return (
      //     <CDateRangePicker
      //       size="sm"
      //       startDate={startDate}
      //       endDate={endDate}
      //       // maxDate={new Date()}
      //       onStartDateChange={(date) => {
      //         setStartDate(date)
      //         onChange((item) => {
      //           if (date) {
      //             const itemDate = new Date(Date.parse(item))
      //             return endDate ? itemDate >= date && itemDate <= endDate : itemDate >= date
      //           }
      //           return true
      //         })
      //       }}
      //       onEndDateChange={(date) => {
      //         setEndDate(date)
      //         onChange((item) => {
      //           if (date) {
      //             const itemDate = new Date(Date.parse(item))
      //             return startDate ? itemDate <= date && itemDate >= startDate : itemDate <= date
      //           }
      //           return true
      //         })
      //       }}
      //     />
      //   )
      // },
    },
  ];
}

export const columnRefundList = () => {
  return [
    {
      key: "refund_uuid",
      label: "Refund ID",
      filter: false,
      sorter: false,
    },
    {
      key: "transaction_uuid",
      label: "Transaction ID",
      filter: false,
      sorter: false
    },
    {
      key: "refund_amount",
      label: "Refund Amount",
      filter: false,
      sorter: false
    },
    {
      key: "refund_status",
      label: "Type",
      filter: false,
      sorter: false
    },
    {
      key: "is_refunded",
      label: "Status",
      filter: false,
      sorter: false
    },
    {
      key: "createdAt",
      label: "Refund Date",
      filter: false,
      sorter: false
    },
    {
      key: "action",
      label: "",
      filter: false,
      sorter: false
    },
  ]
};
